// 负责顶部导航与购物车入口，与 storefront 顶层状态关联。
import { ShoppingBag } from "lucide-react";

type TopbarProps = {
  itemCount: number;
  onToggleCart: () => void;
};

export const Topbar = ({ itemCount, onToggleCart }: TopbarProps) => {
  return (
    <header className="topbar">
      <a className="brand" href="#catalog" aria-label="Luma Atelier home">
        Luma Atelier
      </a>
      <nav className="topnav" aria-label="Store navigation">
        <a href="#catalog">Shop</a>
        <a href="#fit">Fit</a>
        <a href="#shipping">Shipping</a>
      </nav>
      <button
        className="icon-button cart-trigger"
        type="button"
        aria-label={`Open cart with ${itemCount} items`}
        onClick={onToggleCart}
      >
        <ShoppingBag aria-hidden="true" size={20} />
        <span>{itemCount}</span>
      </button>
    </header>
  );
};
